// removed by extract-text-webpack-plugin
module.exports = {"myLink":"_3rfUJY0hL_WwwLp7L9ClBZ"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/MyLinkOut/index.css
// module id = 143
// module chunks = 0